export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const FETCH_COUNTRIES_START = 'FETCH_COUNTRIES_START';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAIL = 'FETCH_COUNTRIES_FAIL';
export const SELECT_COUNTRY = 'SELECT_COUNTRY';
export const FETCH_LEAGUE_INFORMATION = 'FETCH_LEAGUE_INFORMATION';
export const FETCH_LEAGUE_INFORMATION_START = 'FETCH_LEAGUE_INFORMATION_START';
export const FETCH_LEAGUE_INFORMATION_SUCCESS = 'FETCH_LEAGUE_INFORMATION_SUCCESS';
export const SELECT_LEAGUE = 'SELECT_LEAGUE';
export const FETCH_LEAGUE_TABLE_START = 'FETCH_LEAGUE_TABLE_START';
export const FETCH_LEAGUE_TABLE_SUCCESS = 'FETCH_LEAGUE_TABLE_SUCCESS';
export const FETCH_TEAMS_FOR_LEAGUE_SUCCESS = 'FETCH_TEAMS_FOR_LEAGUE_SUCCESS';
export const SELECT_TEAM = 'SELECT_TEAM';
export const FETCH_PLAYERS_FOR_TEAM = 'FETCH_PLAYERS_FOR_TEAM';
export const FETCH_PLAYERS_FOR_TEAM_SUCCESS = 'FETCH_PLAYERS_FOR_TEAM_SUCCESS';

export const FETCH_USER_ACTIVITY = 'FETCH_USER_ACTIVITY';
export const FETCH_USER_ACTIVITY_START = 'FETCH_USER_ACTIVITY_START';
export const FETCH_USER_ACTIVITY_SUCCESS = 'FETCH_USER_ACTIVITY_SUCCESS';

export const FETCH_LIVE_SCORE = 'FETCH_LIVE_SCORE';
export const FETCH_LIVE_SCORE_START = 'FETCH_LIVE_SCORE_START';
export const FETCH_LIVE_SCORE_SUCCESS = 'FETCH_LIVE_SCORE_SUCCESS';

export const FETCH_FIXTURE = 'FETCH_FIXTURE';
export const FETCH_FIXTURE_START = 'FETCH_FIXTURE_START';
export const FETCH_FIXTURE_SUCCESS = 'FETCH_FIXTURE_SUCCESS';

export const FETCH_PLAYER = 'FETCH_PLAYER';
export const FETCH_PLAYER_START = 'FETCH_PLAYER_START';
export const FETCH_PLAYER_SUCCESS = 'FETCH_PLAYER_SUCCESS';

export const FETCH_TOP_SCORER = 'FETCH_TOP_SCORER';
export const FETCH_TOP_SCORER_SUCCESS = 'FETCH_TOP_SCORER_SUCCESS';

// Nasa
export const FETCH_PICTURE_OF_THE_DAY = 'FETCH_PICTURE_OF_THE_DAY';
export const FETCH_PICTURE_OF_THE_DAY_START = 'FETCH_PICTURE_OF_THE_DAY_START';
export const FETCH_PICTURE_OF_THE_DAY_SUCCESS = 'FETCH_PICTURE_OF_THE_DAY_SUCCESS';


export const FETCH_SPACE_STATION = 'FETCH_SPACE_STATION';
export const FETCH_SPACE_STATION_START = 'FETCH_SPACE_STATION_START';
export const FETCH_SPACE_STATION_SUCCESS = 'FETCH_SPACE_STATION_SUCCESS';

// Burger Builder
export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT';
export const SET_INGREDIENTS = 'SET_INGREDIENTS';
export const FETCH_INGREDIENTS_FAILED = 'FETCH_INGREDIENTS_FAILED';

export const PURCHASE_BURGER_START = 'PURCHASE_BURGER_START';
export const PURCHASE_BURGER_SUCCESS = 'PURCHASE_BURGER_SUCCESS';
export const PURCHASE_BURGER_FAIL = 'PURCHASE_BURGER_FAIL';
export const PURCHASE_INIT = 'PURCHASE_INIT';

export const FETCH_ORDERS_START = 'FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL = 'FETCH_ORDERS_FAIL';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';